import { useQuery, UseQueryResult } from "react-query";

import axios from "../../../../utils/authAxios";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL + "/BusinessLicensePermitDashboard";

export const BLP_RECENT_ACTIVITIES_QUERY_KEY = "GetBLPRecentActivities";

export interface BLPRecentActivityRecordDto {
  recordId: number;
  recordName: string;
  busLicensePermitTypeName?: string | null;
  article?: string | null;
  officeName?: string | null;
}

export interface BLPRecentActivityDto {
  id: number;
  recordId?: number | null;
  recordCount: number;
  createdBy?: string | null;
  displayCreatedBy?: string | null;
  createdOn?: string | null;
  action?: string | null;
  records: BLPRecentActivityRecordDto[];
}

export const getBLPRecentActivities = async (
  top: number = 7,
): Promise<BLPRecentActivityDto[]> => {
  const { data } = await axios.get<BLPRecentActivityDto[]>(
    `${apiBaseUrl}/RecentActivities`,
    {
      params: {
        top,
      },
    },
  );

  return Array.isArray(data) ? data : [];
};

export const useBLPRecentActivities = (
  top: number = 7,
  enabled: boolean = true,
): UseQueryResult<BLPRecentActivityDto[], Error> => {
  return useQuery<BLPRecentActivityDto[], Error>(
    [BLP_RECENT_ACTIVITIES_QUERY_KEY, top],
    () => getBLPRecentActivities(top),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );
};
